export default __webpack_public_path__ + "static/media/027-0.99977bad.svg";